module.exports = __webpack_public_path__ + "static/media/icone-ponto-onibus.6709a9d4.svg";